import Figure from "~/components/figure"
import Circuit from "~/components/circuit"

export default class Pathways2 extends Component {
  render() {
    return (
      <Surface gridColumn="screen" alignItems="center">
        <Surface
          justifyContent="space-between"
          alignSelf="center"
          flexFlow="row"
        >
          <Circuit
            circuitProps={{
              moduleWidth: "auto",
              firstActiveNeurons: [`mixed4b:409`, `mixed4b:418`],
            }}
            inlineLayerNames
            circuit={[
              {
                name: "mixed4a",
                modules: [
                  {
                    name: "Left",
                    neurons: [222, 325],
                  },
                  {
                    name: "Right",
                    neurons: [308, 234],
                  },
                ],
              },
              {
                name: "mixed4b",
                modules: [
                  {
                    name: "Invariant",
                    neurons: [409, 418],
                  },
                ],
              },
            ]}
          />

          <Circuit
            circuitProps={{
              moduleWidth: "auto",
              firstActiveNeurons: [`mixed4c:178`, `mixed4c:346`],
            }}
            inlineLayerNames
            circuit={[
              {
                name: "mixed4b",
                modules: [
                  {
                    name: "Left",
                    neurons: [429, 384],
                  },
                  {
                    name: "Right",
                    neurons: [443, 431],
                  },
                ],
              },
              {
                name: "mixed4c",
                modules: [
                  {
                    name: "Invariant",
                    neurons: [178, 346],
                  },
                ],
              },
            ]}
          />
        </Surface>
      </Surface>
    )
  }
}
